'use strict';

// a Vuex store. The store is simply a tree of objects which contain data, and associated methods which implement logic.
// The structure of the store doesn’t have to reflect the structure of components in any way. While components represent visual parts of the page, the modules of the store represent different areas of logic. The data in the store can be mapped to components in a flexible way.

import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

// as-namnen på dessa är för att de ska ha dessa namn i store:

import { ssoStatestoreOversikt as oversikt } from 'v-store/ssoStatestore_Oversikt';
import { ssoStatestoreKontoplan as kontoplan } from 'v-store/ssoStatestore_Kontoplan';
import { ssoStatestoreKontoutdrag as kontoutdrag } from 'v-store/ssoStatestore_Kontoutdrag';
import { ssoStatestoreAvstamning as avstamning } from 'v-store/ssoStatestore_Avstamning';
import { ssoStatestoreVerifikat as verifikat } from 'v-store/ssoStatestore_Verifikat';
import { ssoStatestoreDiagramsidaRapport as diagramsidaRapport } from 'v-store/ssoStatestore_DiagramsidaRapport';
import { ssoStatestoreSok as sok } from 'v-store/ssoStatestore_Sok';


/* eslint-disable import/no-duplicates */
// Dessa använder samma state-modul:
import { ssoStatestoreReskontra as kundreskontra } from 'v-store/ssoStatestore_Reskontra';
import { ssoStatestoreReskontra as leverantorsreskontra } from 'v-store/ssoStatestore_Reskontra';
import { ssoStatestoreReskontra as kundreskontraMini } from 'v-store/ssoStatestore_Reskontra';
import { ssoStatestoreReskontra as leverantorsreskontraMini } from 'v-store/ssoStatestore_Reskontra';

import { ssoStatestoreForteckning as forteckning } from 'v-store/ssoStatestore_Forteckning';

// Dessa använder samma state-modul:
import { ssoStatestoreFaktura as kundfaktura } from 'v-store/ssoStatestore_FakturaForteckningspost';
import { ssoStatestoreFaktura as leverantorsfaktura } from 'v-store/ssoStatestore_FakturaForteckningspost';
import { ssoStatestoreFaktura as kundfakturaMini } from 'v-store/ssoStatestore_FakturaForteckningspost';
import { ssoStatestoreFaktura as leverantorsfakturaMini } from 'v-store/ssoStatestore_FakturaForteckningspost';
import { ssoStatestoreFaktura as forteckningspost } from 'v-store/ssoStatestore_FakturaForteckningspost';

// Dessa använder samma state-modul:
import { ssoStatestoreKundLeverantor as kund } from 'v-store/ssoStatestore_KundLeverantor';
import { ssoStatestoreKundLeverantor as leverantor } from 'v-store/ssoStatestore_KundLeverantor';

// Dessa använder samma state-modul:
import { ssoStatestoreRapport as resultat } from 'v-store/ssoStatestore_Rapport';
import { ssoStatestoreRapport as tillgangar } from 'v-store/ssoStatestore_Rapport';
import { ssoStatestoreRapport as skulder } from 'v-store/ssoStatestore_Rapport';
/* eslint-enable import/no-duplicates */


Vue.use(Vuex);

// Create a VuexPersist object (https://github.com/championswimmer/vuex-persist):
const vuexPersist = new VuexPersist({
	key: 'sso',
	storage: window.localStorage

	// Todo: TMP!!!
	//restoreState: (key, storage) => console.log('restoreState'),
	//saveState: (key, state, storage) => console.log('saveState'),
});

const store = new Vuex.Store({

	// https://vuex.vuejs.org/en/strict.html:
	//strict: process.env.NODE_ENV !== 'production',

	// "Root state":
	state: {
		//arIRedigeralage: false,
		inloggningsbildNr: 1,
	},

	// "Root mutations":
	mutations: {

		//setArIRedigeraLage(state, nyttVarde)
		//{
		//	state.arIRedigeralage = nyttVarde;
		//},

		setInloggningsbildNr(state, nyttVarde)
		{
			state.inloggningsbildNr = nyttVarde;
		},

		// Denna muterar state för rätt module/namespace:
		// nyttVardeObjekt har dessa properties:
		// {
		//		vuexNamespace,
		//		elementId,
		//		nyttScrollTopvarde
		setScrollTopForRullningsbartElement(state, nyttVardeObjekt)
		{
			// `state` is the GLOBAL state, NOT the local module state:

			state[nyttVardeObjekt.vuexNamespace].rullningsbaraElement
				.find(x => x.id === nyttVardeObjekt.elementId)
					.scrollTop = nyttVardeObjekt.nyttScrollTopvarde;
		}
	},

	// "Root getters":
	//getters: {
	//	doneTodos: state =>
	//	{
	//		return state.todos.filter(todo => todo.done)
	//	},
	//	doneTodosCount: (state, getters) =>
	//	{
	//		return getters.doneTodos.length
	//	},
	//},

	// "Root actions":
	//actions: { ... },

	// Warning: when working with modules these should be registered in the Vuex constructor. When using store.registerModule you risk the (restored) persisted state being overwritten with the default state defined in the module itself:
	plugins: [vuexPersist.plugin],

	modules: {
		// Dessa kommer från importer ovan:
		oversikt,
		kontoplan,
		kontoutdrag,
		avstamning,
		verifikat,
		diagramsidaRapport,
		sok,

		kundreskontra,
		leverantorsreskontra,
		kundreskontraMini,
		leverantorsreskontraMini,

		forteckning,

		kundfaktura,
		leverantorsfaktura,
		kundfakturaMini,
		leverantorsfakturaMini,
		forteckningspost,

		kund,
		leverantor,

		resultat,
		tillgangar,
		skulder
	}
});

export { store as ssoStatestore };


